import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling } from '@src/utils';
import { environmentsActions } from '@src/store/reducers/environmentsReducer';

export const createEnvironmentsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [environmentsActions.GET_ENVIRONMENT]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/${action.payload.id}/EnvTypesWithEnvsAndDepStatus`);
                const environment = { projectId: action.payload.id, types: response.data };
                next({ type: environmentsActions.SET_ENVIRONMENT, payload: { environment } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        /*[environmentsActions.GET_VERSIONS_FOR_UPGRADE_BY_VERSION]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForDeployByVersion/PageNumber/1/PageSize/50`;
            const response = await http.get(url);
            next({ type: environmentsActions.SET_VERSIONS_FOR_UPGRADE_BY_VERSION, payload: { versionsForUpgrade: response.data } });
            return response;
        },*/
        [environmentsActions.GET_VERSIONS_FOR_UPGRADE]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForDeploy`);
            next({ type: environmentsActions.SET_VERSIONS_FOR_UPGRADE, payload: { versionsForUpgrade: response.data } });
            return response;
        },
        [environmentsActions.UPGRADE_PREVALIDATE_TO_VERSION]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Packages/${payload.packageId}/${payload.type}`;
            const response = await http.put(url, payload.body);
            return response;
        },
        [environmentsActions.UPGRADE_PREVALIDATE_BY_TASK]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/${payload.type}`;
            const response = await http.put(url, payload.body);
            return response;
        },
        [environmentsActions.GET_VERSIONS_FOR_SET]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/RMSourceDeployedPackages`;
            const response = await http.get(url);
            next({ type: environmentsActions.SET_VERSIONS_FOR_SET, payload: { versionsForSet: response.data } });
            return response;
        },
        [environmentsActions.SET_TO_VERSION]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Packages/${payload.packageId}/Set`;
            payload.force = false;        
            const response = await http.put(url, payload.force, { timeout: 600000 });
            return response;
        },
        [environmentsActions.EXIT_INTEGRATION]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/SetSchemasIntegrationState`;
            const response = await http.put(url, payload.body);
            return response;
        },
        [environmentsActions.GET_ENV_TYPES]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/EnvironmentTypes`);
            next({ type: action.type, payload: response.data });
            return response;
        },
        [environmentsActions.GET_ENV_DETAILS]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Projects/${action.payload.projectId}/EnvTypesWithEnvAndDepStatusByEnvModified/${action.payload.envId}`;
                const response = await http.get(url);
                next({ type: environmentsActions.SET_ENV_DETAILS, payload: { envDetails: response.data[0] } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.GET_ENV_SETTINGS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/Environments/${action.payload.envId}/Settings`);
                const envSettings = {
                    comparisonTypes: response.data.comparisonTypes,
                    baselineTypes: response.data.baselineTypes,
                    description: response.data.description
                };
                next({ type: environmentsActions.SET_ENV_SETTINGS, payload: { envSettings } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.BUILD]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/BuildByBaseline`;
            const response = await http.post(url, payload.params);
            return response;
        },
        [environmentsActions.BUILDBYTASK]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/BuildByTaskIds`;
            const response = await http.post(url, payload.params);
            return response;
        },
        [environmentsActions.SAVE_ENV_SETTINGS]: async (action: any) => {
            try {
                const url = `${restServiceUrl}Projects/${action.payload.projectId}/Environments/${action.payload.envId}/Settings`;
                const response = await http.post(url, action.payload.params);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.APPLY_LABEL]: async ({payload}: any) => {
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Labels/Apply`;
                const response = await http.post(url,  {labelName:payload.labelName , labelDesc: payload.labelDesc});
                return response;
        },
        [environmentsActions.SET_TYPE]: async (action: any) => {
            try {
                const url = `${restServiceUrl}Projects/${action.payload.projectId}/Environments/${action.payload.envId}/EnvType/${action.payload.id}`;
                const response = await http.put(url);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.GET_LABELS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Labels`);
            next({ type: environmentsActions.SET_LABELS, payload: { labels: response.data } });
            return response;
        },
        [environmentsActions.VALIDATE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Labels/${payload.labelId}/Validate`;
                const response = await http.put(url);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.VALIDATE_BY_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Packages/${payload.validateTypeId}/Validate`;
                const response = await http.put(url, false);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.VALIDATE_BY_LABEL]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Labels/${payload.validateTypeId}/Validate`;
                const response = await http.put(url, false);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.GET_PACKAGES_FOR_ROLLBACK]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForRollback`);
            response.type = environmentsActions.GET_PACKAGES_FOR_ROLLBACK;
            next({ type: environmentsActions.SET_PACKAGES_FOR_ROLLBACK, payload: { packagesForRollback: response.data } });
            return response;
        },
        [environmentsActions.GET_LABELS_FOR_ROLLBACK]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/LabelsForRollback`;
            const response = await http.get(url);
            response.type = environmentsActions.GET_LABELS_FOR_ROLLBACK;
            next({ type: environmentsActions.SET_LABELS_FOR_ROLLBACK, payload: { labelsForRollback: response.data } });
            return response;
        },
        
        [environmentsActions.ROLLBACK_DOWNGRADE_BY_TASK]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/CreateScriptsOnly/${payload.createScriptOnly}/Rollback`;
                const response = await http.put(url,payload.body);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },


        [environmentsActions.ROLLBACK]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Packages/${payload.rollbackTypeId}/Rollback`;
                const response = await http.put(url, payload.body);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.GET_PACKAGES_FOR_VALIDATE]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForValidate`;
            const response = await http.get(url);
            response.type = environmentsActions.GET_PACKAGES_FOR_VALIDATE;
            next({ type: environmentsActions.SET_PACKAGES_FOR_VALIDATE, payload: { packagesForValidate: response.data } });
            return response;
        },
        [environmentsActions.GET_LABELS_FOR_VALIDATE]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/LabelsForValidate`;
            const response = await http.get(url);
            response.type = environmentsActions.GET_LABELS_FOR_VALIDATE;
            next({ type: environmentsActions.SET_LABELS_FOR_VALIDATE, payload: { labelsForValidate: response.data } });
            return response;
        },
        
        [environmentsActions.GET_PACKAGES_FOR_ROLLBACK_BY_TASK]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForRollbackByTask/PageNumber`
                + `/${payload.pageNumber}/PageSize/${payload.pageSize}`;
            const response = await http.post(url, payload);
            return response;
        },
        [environmentsActions.GET_PACKAGES_FOR_DEPLOY_BY_TASK]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/PackagesForDeployByTask/PageNumber`
                + `/${payload.pageNumber}/PageSize/${payload.pageSize}`;
            const response = await http.post(url, payload);
            return response;
        },
        [environmentsActions.GET_ENV_SCHEMA]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Schemes`);
            return response;
        },
        [environmentsActions.ROLLBACK_BY_LABEL]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Labels/${payload.rollbackTypeId}/Rollback`;
                const response = await http.put(url, payload.body);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.UPDATE_DEV_ENV]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}`
                    + `/Environments/${payload.envId}/${payload.isPackageByLabel ? 'Label' : 'Package'}`
                    + `/${payload.packageId}/skipCheckedOut/${payload.skipCheckedOut}`
                    + `/createScriptOnly/${payload.createScriptOnly}/DevGetVersion/DevGetVersion`;
                const response = await http.put(url, payload.baselineId);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.RUN_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}`
                    + `/Environments/${payload.envId}/Packages/${payload.packageId}`
                    + `/ScriptType/${payload.scriptType}/DevUpdate`;
                const response = await http.put(url, payload.skipCheckedOut);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [environmentsActions.GET_BASELINE_FOR_GET_LATEST]: async (action: any) => {
            const url = `${restServiceUrl}Projects/${action.payload.projectId}`
                + `/Environments/${action.payload.envId}/GetBaselineForGetLatest`;
            const response = await http.get(url);
            return response;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/environments.middleware.ts